<mat-card-title>
  <div
    class="flex flex-col gap-3 sm:flex-row sm:justify-between sm:items-center"
  >
    <h2 class="text-xl font-medium">
      @if (dragFieldsEnabled) {
        <mat-icon cdkDragHandle class="cursor-move pt-1"
          >drag_indicator</mat-icon
        >
      }
      {{ fieldTitle }}
    </h2>
    <div>
      @if (isConditionBroken) {
        <mat-icon
          class="text-red-500 text-[20px] h-5 w-5"
          matTooltip="La condizione impostata non è più valida (il campo padre potrebbe essere stato eliminato o modificato). Clicca su Gestisci Elemento per sistemare."
        >
          warning
        </mat-icon>
      }
      <button
        mat-icon-button
        type="button"
        (click)="onClickManageField()"
        matTooltip="Gestisci elemento"
        class="section-icon-button"
        aria-label="Gestisci elemento"
        [disabled]="dragFieldsEnabled"
      >
        <mat-icon>settings</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="duplicate.emit(fieldId)"
        class="section-icon-button"
        matTooltip="Duplica elemento"
        aria-label="Duplica elemento"
        [disabled]="dragFieldsEnabled"
      >
        <mat-icon>content_copy</mat-icon>
      </button>
      <button
        type="button"
        mat-icon-button
        (click)="delete.emit(fieldId)"
        class="section-icon-button"
        matTooltip="Elimina elemento"
        aria-label="Elimina elemento"
        [disabled]="dragFieldsEnabled || disableDelete"
      >
        <mat-icon class="material-icons-outlined">delete</mat-icon>
      </button>
    </div>
  </div>
  <hr class="mt-0" />
</mat-card-title>
<mat-card-content class="p-0!">
  <form [formGroup]="fieldForm">
    <div>
      <siat-switch-type-field
        [fieldForm]="fieldForm"
        class="switch-type-select"
        (onChangeSelect)="onTypeChange($event)"
      ></siat-switch-type-field>
    </div>
    <div class="mt-3">
      @let fieldType = fieldForm.get('type')?.value;
      @let requiredOptions =
        [
          fieldType === fieldTypeEnum.CHECKBOX ||
            fieldType === fieldTypeEnum.RADIOBUTTON ||
            fieldType === fieldTypeEnum.SELECT,
        ];

      @if (
        !isScaleField(fieldType) &&
        fieldType !== fieldTypeEnum.PRIORITY &&
        fieldType !== fieldTypeEnum.NAZIONE &&
        fieldType !== fieldTypeEnum.REGIONI_PROVINCE_COMUNI &&
        fieldType !== fieldTypeEnum.EMAIL &&
        fieldType !== fieldTypeEnum.TELEFONO &&
        fieldType !== fieldTypeEnum.CODICE_FISCALE &&
        fieldType !== fieldTypeEnum.TYPOLOGY
      ) {
        <siat-input-field
          [id]="fieldId + '_label'"
          [name]="fieldId + '_label'"
          appearance="outline"
          [formGroup]="fieldForm"
          controlName="label"
          type="text"
          [label]="
            'Label elemento ' + fieldIndex + ' - Sezione ' + sectionIndex
          "
          [placeholder]="
            'Inserisci label elemento ' +
            fieldIndex +
            ' - Sezione ' +
            sectionIndex
          "
        ></siat-input-field>

        @if (
          fieldType === fieldTypeEnum.TEXT ||
          fieldType === fieldTypeEnum.TEXTAREA ||
          fieldType === fieldTypeEnum.ACCORDION
        ) {
          <div class="mt-3">
            <siat-input-field
              [id]="fieldId + '_placeholder'"
              [name]="fieldId + '_placeholder'"
              appearance="outline"
              [formGroup]="fieldForm"
              controlName="placeholder"
              type="text"
              [label]="
                'Placeholder elemento ' +
                fieldIndex +
                ' - Sezione ' +
                sectionIndex
              "
              [placeholder]="
                'Inserisci placeholder elemento ' +
                fieldIndex +
                ' - Sezione ' +
                sectionIndex
              "
            ></siat-input-field>
          </div>
        }
      }

      @if (requiredOptions[0] && optionsFormArray) {
        @for (
          group of optionsFormArray.controls;
          track trackByOption($index);
          let i = $index
        ) {
          <div
            [formGroup]="getOptionsFormGroup(i)"
            class="w-full pr-2 mt-3 mb-3"
          >
            <div class="flex items-center gap-2 w-full">
              @switch (fieldType) {
                @case ('checkbox') {
                  <mat-icon> check_box_outline_blank </mat-icon>
                }
                @case ('radiobutton') {
                  <mat-icon> radio_button_unchecked </mat-icon>
                }
                @case ('select') {
                  <span> {{ i + 1 + '.' }} </span>
                }
              }

              <div class="w-full">
                <siat-input-field
                  [id]="fieldId + '_option_' + i"
                  [name]="fieldId + '_option_' + i"
                  appearance="outline"
                  class="w-full"
                  controlName="name"
                  [formGroup]="getOptionsFormGroup(i)"
                  type="text"
                  [label]="'Opzione ' + (i + 1)"
                  [placeholder]="
                    'Inserisci denominazione per opzione ' + (i + 1)
                  "
                ></siat-input-field>
              </div>

              <button
                matIconButton
                matTooltip="Elimina"
                [attr.aria-label]="'Elimina'"
                type="button"
                class="section-icon-button"
                [disabled]="optionsFormArray?.controls.length <= 1"
                (click)="onClickDeleteOption(i)"
              >
                <mat-icon class="material-icons-outlined">delete</mat-icon>
              </button>
            </div>
          </div>
        }
        <div class="mt-3">
          <button
            type="button"
            matButton="outlined"
            matTooltip="Clicca per aggiungere un'opzione"
            class="w-full"
            (click)="onClickAddOption()"
            [attr.aria-label]="'Aggiungi opzione'"
          >
            Aggiungi opzione
            <mat-icon class="material-icons-outlined"> add_circle </mat-icon>
          </button>
        </div>
      }

      @if (fieldType === fieldTypeEnum.TYPOLOGY) {
        <div class="mt-3 flex flex-row items-center gap-4">
          <siat-select-field
            [id]="fieldId + 'select_endpoint'"
            [name]="fieldId + 'select_endpoint'"
            appearance="outline"
            class="w-full"
            controlName="endpoint"
            [formGroup]="fieldForm"
            type="text"
            [label]="'Endpoint disponibili'"
            [placeholder]="'Seleziona la risorsa dati (Endpoint)'"
            [items]="availableEndpoints()"
          ></siat-select-field>

          <button
            matButton="tonal"
            type="button"
            [disabled]="!fieldForm.get('endpoint').valid"
            aria-label="Test connessione"
            (click)="openTestConnessioneDialog()"
          >
            Test connessione
          </button>
        </div>
      }

      @if (fieldType === fieldTypeEnum.ACCORDION) {
        <div class="mt-4">
          <div class="flex items-center justify-between gap-3">
            <h3 class="text-xl font-medium m-0">Elementi accordion</h3>
            <button
              type="button"
              matButton="outlined"
              matTooltip="Aggiungi elemento all'accordion"
              [attr.aria-label]="'Aggiungi elemento accordion'"
              (click)="addFieldToAccordion()"
              [disabled]="dragFieldsEnabled"
            >
              Aggiungi elemento
              <mat-icon class="material-icons-outlined">add_circle</mat-icon>
            </button>
          </div>

          <div class="mt-3">
            @for (
              childFieldCtrl of accordionFieldsArray.controls;
              track trackByField($index, childFieldCtrl);
              let childIndex = $index
            ) {
              <mat-card
                class="mb-2 mt-3 px-3 pb-3"
                appearance="outlined"
              >
                <siat-field-builder
                  [fieldIndex]="childIndex + 1"
                  [sectionIndex]="sectionIndex"
                  [fieldId]="childFieldCtrl?.getRawValue()?.id"
                  [fieldForm]="getFieldFormGroup(childFieldCtrl)"
                  [dragFieldsEnabled]="dragFieldsEnabled"
                  [isAccordionChild]="true"
                  (duplicate)="
                    duplicateAccordionField(getFieldFormGroup(childFieldCtrl))
                  "
                  (delete)="
                    deleteAccordionField(getFieldFormGroup(childFieldCtrl))
                  "
                />
              </mat-card>
            }
          </div>
        </div>
      }
    </div>
  </form>
</mat-card-content>
